/**
 * If value is a number, returns that, if it is a string, it tries to parse it.
 * This will always return a non-NaN, non-Infinity number.
 *
 * If null, undefined, or unparseable, it returns the defaultValue
 */
export function getNumber(
  value?: number | null | string,
  defaultValue = 0
): number {
  const valueAsNumber = getValueAsNumber(value, defaultValue);

  if (isNaN(valueAsNumber) || !isFinite(valueAsNumber)) {
    return defaultValue;
  }

  return valueAsNumber;
}

function getValueAsNumber(
  value: number | string | undefined | null,
  defaultValue: number
) {
  if (typeof value === "number") {
    return value;
  }

  if (typeof value === "string") {
    const parsed = parseFloat(value);
    return parsed;
  }

  return defaultValue;
}
